export default __webpack_public_path__ + "static/media/upgrade_your_own_business.e9533c53.jpg";